import { render, staticRenderFns } from "./idCardList.vue?vue&type=template&id=f74ab800&scoped=true&"
import script from "./idCardList.vue?vue&type=script&lang=js&"
export * from "./idCardList.vue?vue&type=script&lang=js&"
import style0 from "./idCardList.vue?vue&type=style&index=0&id=f74ab800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ab800",
  null
  
)

export default component.exports